// Locked close-out hotfix: only approved pinned templates for the current channel, at most five.
import { getTemplateDisplayName } from './communicationsTemplates';

export const TEMPLATE_MENU_LIMIT = 5;

function sameChannel(template, channel) {
    if (!channel) return true;
    const own = String(template?.channel || '').toLowerCase();
    return !own || own === String(channel).toLowerCase();
}

/**
 * Pure. Approved, not archived pinned templates for this channel. `whatsappAccountSid` (when given, even null) keeps only WhatsApp
 * templates registered on that sending account, as the side-panel picker does; undefined means "not known, do not filter".
 * Returns { items: [{ template, pinned }], overflow } where items are at most `limit` long.
 */
export function templateMenuEntries({
    templates = [],
    channel = '',
    pinnedIds = [],
    limit = TEMPLATE_MENU_LIMIT,
    whatsappAccountSid,
} = {}) {
    const pinned = new Set(Array.isArray(pinnedIds) ? pinnedIds : []);
    const pinOrder = new Map((Array.isArray(pinnedIds) ? pinnedIds : []).map((sid, index) => [sid, index]));
    const eligible = (Array.isArray(templates) ? templates : []).filter((template) => (
        template
        && template.status === 'approved'
        && !template.archived_at
        && sameChannel(template, channel)
        && (
            String(template.channel || channel || '').toLowerCase() !== 'whatsapp'
            || whatsappAccountSid === undefined
            || (template.twilioAccountSid || null) === (whatsappAccountSid || null)
        )
    ));
    const byName = (left, right) => getTemplateDisplayName(left).localeCompare(getTemplateDisplayName(right), undefined, { sensitivity: 'base' })
        || String(left.sid || '').localeCompare(String(right.sid || ''));
    const pinnedRows = eligible.filter((template) => pinned.has(template.sid))
        .sort((left, right) => (pinOrder.get(left.sid) - pinOrder.get(right.sid)) || byName(left, right));
    const ordered = pinnedRows.map((template) => ({ template, pinned: true }));
    const cap = Number.isFinite(limit) && limit > 0 ? Math.floor(limit) : TEMPLATE_MENU_LIMIT;
    return { items: ordered.slice(0, cap), overflow: false, total: ordered.length };
}
